import axios from './osHelper';

// 角色查询
export const GetRoleList = (params) => {
  return axios({ url: `/v2/role/info`, method: 'POST', params });
};

// 新 角色绑定
export const BindRoleAPI = (data) => {
  return axios({ url: '/v2/role/binds', method: 'POST', data });
};



// WEBPACK FOOTER //
// ./src/pages/tideng/new-version/new-os.js